
import './RentDirectPage.css';
import YourBrand from '../YourBrand/YourBrand';
import React, { useEffect, useState, useRef } from "react";
//import { Modal } from 'react-bootstrap';
import AIheader from '../../../pages/RentAI/AIheader';
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

const RentDirectPage = ()=>{

 // Define all tabs and their corresponding states dynamically
 const [currentTabIndexMorden, setCurrentTabIndexMorden] = useState(0);
 const [currentTabIndexMarketing, setCurrentTabIndexMarketing] = useState(0);
 const [currentTabIndexFleet, setCurrentTabIndexFleet] = useState(0);
 const [currentTabCustomer, setCurrentTabIndexCustomer] = useState(0);
 const [currentTabFinancial, setCurrentTabIndexFinancial] = useState(0);
 //const autoplayIntervalRef = useRef(null);
 //const autoplayIntervalRef1 = useRef(null);
 //const autoplayIntervalRef2 = useRef(null);
 //const autoplayIntervalRef3 = useRef(null);
// const autoplayIntervalRef4= useRef(null);

  const sectionRef = useRef(null);
  const sectionRef1 = useRef(null);
  const sectionRef2 = useRef(null);
  const sectionRef3 = useRef(null);
  const sectionRef4 = useRef(null);



  const tabsMordern = [
    { id: "tabMorden_1", label: "Host Booking Experience" },
      { id: "tabMorden_2", label: "Guest Booking Experience" },
      
    ];


  const tabsData = [
    { id: "tabMarketing_1", label: "Quotes" },
      { id: "tabMarketing_2", label: "Promotions" },
      { id: "tabMarketing_3", label: "Spotlight" }
      
    ];

     const fleettabs = [
          { id: "fleettab1", label: "Booking Calender" },
          { id: "fleettab2", label: "Fleet Manager" },
          { id: "fleettab3", label: "Vehicle Profile" },
          { id: "fleettab4", label: "Telematics & Tracking" }
        ];


        const customerrelationshipettabs = [
            { id: "customerRelationship_1", label: "Review Management" },
            { id: "customerRelationship_2", label: "Comprenhensive Guest Profile" },
            { id: "customerRelationship_3", label: "Scheduled Messages" },
          ];
        
          const financialtabs = [
            { id: "financialManagements_1", label: "Dynamic Invoices" },
            { id: "financialManagements_2", label: "Dynamic Agreements" },
            { id: "financialManagements_3", label: "Payment Methods" },
          ];
    

     const changeTab = (index) => {
        setCurrentTabIndexMarketing(index);
        //setCurrentTabIndexMarketing((prevIndex) => (prevIndex + 1) % tabsData.length);
      };

      //old code for the url # remove
    /*  useEffect(() => {
        const tabIdFromUrl = window.location.hash; // Get the hash from the URL
    
        if (tabIdFromUrl) {
            // Check if it's a Fleet tab
            const fleetTabIndex = fleettabs.findIndex(tab => `#${tab.id}` === tabIdFromUrl);
            if (fleetTabIndex !== -1) {
                setCurrentTabIndexFleet(fleetTabIndex);
                scrollToTab(tabIdFromUrl);
                return; // Stop execution here to avoid setting marketing tabs too
            }
    
            // Check if it's a Marketing tab
            const marketingTabIndex = tabsData.findIndex(tab => `#${tab.id}` === tabIdFromUrl);
            if (marketingTabIndex !== -1) {
                setCurrentTabIndexMarketing(marketingTabIndex);
                scrollToTab(tabIdFromUrl);
                return;
            }

             // Check if it's a Customer Relationship tab
        const customerTabIndex = customerrelationshipettabs.findIndex(tab => `#${tab.id}` === tabIdFromUrl);
        if (customerTabIndex !== -1) {
            setCurrentTabIndexCustomer(customerTabIndex);
            scrollToTab(tabIdFromUrl);
            return;
        }

             // Check if it's a Financial Management tab
             const financialTabIndex = financialtabs.findIndex(tab => `#${tab.id}` === tabIdFromUrl);
             if (financialTabIndex !== -1) {
                setCurrentTabIndexFinancial(financialTabIndex);
                scrollToTab(tabIdFromUrl);
                 return;
             }
        }
    }, []);*/
    
    // new function for remove # from url..
    /*const scrollToTab = (tabId) => {
        const element = document.getElementById(tabId.replace("#", ""));
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
    
            // **Remove hash after scroll completes**
            setTimeout(() => {
                window.history.replaceState(null, null, window.location.pathname);
            }, 1000); // Wait 1 second to ensure smooth scrolling
        }
    };*/
    

    /* Deep links (owner, 2026-10-02). The hash is either a section id (#FinancialManagement,
       #FleetManagementCenter, #CustomerRelationshipTools, #BrandedDigitalExperiences,
       #SmartBookingManagement) or a tab id inside one of the tabbed sections
       (e.g. #financialManagements_2 = Dynamic Agreements). A tab id selects that tab and then
       scrolls to the START of its section, so the heading and the tab strip are in view.
       Scrolling waits for the layout to settle (images above the target change its position)
       and clears the fixed header. The hash is left in the URL. */
    useEffect(() => {
        const HEADER_OFFSET = 96;
        const groups = [
            { tabs: fleettabs, set: setCurrentTabIndexFleet },
            { tabs: tabsData, set: setCurrentTabIndexMarketing },
            { tabs: customerrelationshipettabs, set: setCurrentTabIndexCustomer },
            { tabs: financialtabs, set: setCurrentTabIndexFinancial },
        ];
        const SECTION_IDS = ["SmartBookingManagement", "BrandedDigitalExperiences", "FleetManagementCenter", "CustomerRelationshipTools", "FinancialManagement"];
        let timer = 0;
        const handleHash = () => {
            const id = decodeURIComponent(window.location.hash.replace("#", ""));
            if (!id) return;
            for (const g of groups) {
                const i = g.tabs.findIndex((tab) => tab.id === id);
                if (i !== -1) g.set(i);
            }
            let tries = 0;
            let lastTop = null;
            const seek = () => {
                const el = document.getElementById(id);
                if (!el) { if (tries++ < 30) timer = window.setTimeout(seek, 100); return; }
                const section = SECTION_IDS.includes(id) ? el : (el.closest(SECTION_IDS.map((x) => "#" + x).join(", ")) || el);
                const top = Math.round(section.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET);
                window.scrollTo({ top, behavior: tries === 0 ? "auto" : "auto" });
                // Keep re-aligning for a moment while images above the target finish laying out.
                if (tries++ < 12 && (lastTop === null || Math.abs(top - lastTop) > 1 || tries < 6)) { lastTop = top; timer = window.setTimeout(seek, 150); }
            };
            seek();
        };
        handleHash();
        window.addEventListener("hashchange", handleHash);
        return () => { window.clearTimeout(timer); window.removeEventListener("hashchange", handleHash); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    
    

      const changeTab1 = (index) => {
        setCurrentTabIndexFleet(index);
        //setCurrentTabIndexFleet((prevIndex) => (prevIndex + 1) % fleettabs.length);
      };

      
      const changeTab2 = (index) => {
        setCurrentTabIndexCustomer(index);
       //setCurrentTabIndexCustomer((prevIndex) => (prevIndex + 1) % customerrelationshipettabs.length);
      };

        
      const changeTab3 = (index) => {
        setCurrentTabIndexFinancial(index);
        //setCurrentTabIndexFinancial((prevIndex) => (prevIndex + 1) % financialtabs.length);
      };
    
 

    const changeTab4 = (index) => {
        setCurrentTabIndexMorden(index);
       // setCurrentTabIndexMorden((prevIndex) => (prevIndex + 1) % tabsMordern.length);  
    };
    
    
    
    /*  const startAutoplay = () => {
      
    //     if (!autoplayIntervalRef.current) {
    //       autoplayIntervalRef.current = setInterval(changeTab, 3000);
    //     }
       };

      const startAutoplay1 = () => {
        if (!autoplayIntervalRef1.current) {
          autoplayIntervalRef1.current = setInterval(changeTab1, 3000);
        }
      };

      
      const startAutoplay2 = () => {
      
        if (!autoplayIntervalRef2.current) {
            autoplayIntervalRef2.current = setInterval(changeTab2, 3000);
        }
      };

      const startAutoplay3 = () => {
      
        if (!autoplayIntervalRef3.current) {
          autoplayIntervalRef3.current = setInterval(changeTab3, 3000);
        }
      };

      const startAutoplay4 = () => {
        if (!autoplayIntervalRef4.current) {
            autoplayIntervalRef4.current = setInterval(changeTab4, 3000);
        }
      };
    
      const stopAutoplay = () => {
        if (autoplayIntervalRef.current) {
          clearInterval(autoplayIntervalRef.current);
          autoplayIntervalRef.current = null;
        }
        setCurrentTabIndexMarketing(0); 
        // Reset to first tab
      };

      const stopAutoplay1 = () => {
        if (autoplayIntervalRef1.current) {
          clearInterval(autoplayIntervalRef1.current);
          autoplayIntervalRef1.current = null;
        }
        setCurrentTabIndexFleet(0);
      };

      const stopAutoplay2 = () => {
        if (autoplayIntervalRef2.current) {
          clearInterval(autoplayIntervalRef2.current);
          autoplayIntervalRef2.current = null;
        }
        setCurrentTabIndexCustomer(0);
      };

      const stopAutoplay3 = () => {
        if (autoplayIntervalRef3.current) {
          clearInterval(autoplayIntervalRef3.current);
          autoplayIntervalRef3.current = null;
        }
        setCurrentTabIndexFinancial(0); 
        // Reset to first tab
      };

      const stopAutoplay4 = () => {
        if (autoplayIntervalRef4.current) {
          clearInterval(autoplayIntervalRef4.current);
          autoplayIntervalRef4.current = null;
        }
        setCurrentTabIndexMorden(0); 
        // Reset to first tab
      };*/
    
      const handleScroll = () => {
        if (!sectionRef.current) return;
        if (!sectionRef1.current) return;
        if (!sectionRef2.current) return;
        if (!sectionRef3.current) return;
        if (!sectionRef4.current) return;
    
        //const rect = sectionRef.current.getBoundingClientRect();
        //const rect1 = sectionRef1.current.getBoundingClientRect();
        //const rect2 = sectionRef2.current.getBoundingClientRect();
       // const rect3 = sectionRef3.current.getBoundingClientRect();
       // const rect4 = sectionRef4.current.getBoundingClientRect();
       // const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
       // const isVisible1 = rect1.top < window.innerHeight && rect1.bottom > 0;
       // const isVisible2 = rect2.top < window.innerHeight && rect2.bottom > 0;
        //const isVisible3 = rect3.top < window.innerHeight && rect3.bottom > 0;
       // const isVisible4 = rect4.top < window.innerHeight && rect4.bottom > 0;
    
       /* if (isVisible) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
        if (isVisible1) {
           
            startAutoplay1();
          } else {
            stopAutoplay1();
          }
          if (isVisible2) {
            startAutoplay2();
          } else {
            stopAutoplay2();
          }

          if (isVisible3) {
            startAutoplay3();
          } else {
            stopAutoplay3();
          }

          
          if (isVisible4) {
            startAutoplay4();
          } else {
            stopAutoplay4();
          }*/
        
        
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
          //stopAutoplay(); // Cleanup on unmount
        };
      }, []);

  /*useEffect(() => {
    const interval = setInterval(() => {
      tabsData.forEach(({ tabs, currentIndex, setIndex }) => {
        const nextTabIndex = (currentIndex + 1) % tabs.length; // Calculate next index
        const nextTabId = tabs[nextTabIndex]; // Get next tab ID

        // Safely select the next tab element
        const nextTabElement = document.getElementById(nextTabId);
        if (nextTabElement) {
          const nextTab = new Tab(nextTabElement);
          nextTab.show(); // Show the next tab
          setIndex(nextTabIndex); // Update state
        } else {
          console.warn(`Tab element with ID "${nextTabId}" not found.`);
        }
      });
    }, 5000); // Switch every 6 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [tabsData]);*/




    return(
        <>
        <AIheader/>
        <div className="rd-legacy">


        {/* START bannerInnerMain */}
        <section className="bannerInnerMain bannerDirectMain">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="bannerPageInner">
                            <figure><img src="/logos/products/rentdirect-white.png" alt="Car rental management software, only better"/></figure>
                            <h1>Car rental management software, only better.</h1>
                            <p>Everything you need to manage your car rental fleet, increase profits, and keep your brand front and center.</p>
                            {/* <div className="bannerBtn">
                                <a href="#" className="btn">
                                <span>Watch Video</span>
                                <img width="16px" src="/img/video_play.svg" alt="rent id"/>
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* END bannerInnerMain */}


        {/* START insuranceSecMain */}
        <section className='insuranceSecMain insuranceDirectMain'>  
            <div className='container'>
                <div className='row align-items-end'>
                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                        <div className='insuranceDirectLeft'>
                            <h6>AUTOMATED RENTAL WORKFLOWS</h6>
                            <h2>All-in-One Vehicle Rental Management Platform</h2>
                            <p>The only rental platform that self-manages operations, automates tasks, and enhances customer experiences while providing powerful tools to optimize business efficiency, maximize revenue, and drive growth.</p>
                            <ul>
                                <li>
                                    <a href="#SmartBookingManagement">
                                        <img src="/img/calendar_icon_2.svg" alt="Smart Booking Management"/>
                                        Smart Booking Management
                                    </a>
                                </li>
                                <li>
                                    <a href="#BrandedDigitalExperiences">
                                        <img src="/img/phone_icon_2.svg" alt="Branded Digital Experiences"/> 
                                        Branded Digital Experiences
                                    </a>
                                </li>
                                <li>
                                    <a href="#FleetManagementCenter">
                                        <img src="/img/car_icon_2.svg" alt="Fleet Management Center"/> 
                                        Fleet Management Center
                                    </a>
                                </li>

                                <li>
                                    <a href="#CustomerRelationshipTools">
                                        <img src="/img/user_icon_2.svg" alt="Customer Relationship Tools"/> 
                                        Customer Relationship Tools
                                    </a>
                                </li>

                                <li>
                                    <a href="#FinancialManagement">
                                        <img src="/img/chart_icon_2.svg" alt="Financial Management"/> 
                                        Financial Management
                                    </a>
                                </li>
                                <li>
                                    <a href="#AnalyticsReporting">
                                        <img src="/img/analytics_icon_2.svg" alt="Analytics & Reporting"/>
                                        Analytics & Reporting
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                        <div className='insuranceRight'>
                            <div className='insuranceRightImage'>
                                <img className="img-fluid" src="/img/rentdirect/vehicle_Rentid.jpg" alt="insurance" />
                            </div>
                            <div className='auto-insurance-sec'>
                                <div className='auto-insurance'>
                                    <img src="/img/featured-img1.svg" alt="icon" />    
                                    <div className='inner-text-sec'>
                                        <h5>Rental Operational Workflows</h5>
                                        <p>Automations that keep your business efficiente.</p>
                                    </div>
                                </div>
                                <div className='auto-insurance left-space-box'>
                                    <img src="/img/featured-img1.svg" alt="icon" />   
                                    <div className='inner-text-sec'>
                                        <h5>Built-In Administrative Tasks</h5>
                                        <p>Digital management of all paperwork and files.</p>
                                    </div>
                                </div>
                                <div className='auto-insurance left-space-box1'>
                                    <img src="/img/featured-img1.svg" alt="icon" />   
                                    <div className='inner-text-sec'>
                                        <h5>On Demand Logistical Solutions</h5>
                                        <p>Rental logistics tailored to your needs.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* END insuranceSecMain */}


        {/* START mostMordenMain */}
        <div id="SmartBookingManagement">
            <section ref={sectionRef4} className="mostMordenMain mostMorden_DesktopMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="headmostMorden">
                                <h2>The most modern & intuitive booking experience designed for vehicle rental</h2>
                                <p>Say hello to seamless rental operations, customizable and automated booking workflows that enhance productivity.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-11">
                        
                            <ul className="nav nav-tabs">
                                    {tabsMordern.map((tab, index) => (
                                        <li key={tab} className="nav-item">
                                        <a
                                            className={`nav-link ${currentTabIndexMorden === index ? "active" : ""}`}
                                            id={tab.id}
                                            data-bs-toggle="tab"
                                            href={`#${tab.id}`}
                                            onClick={(e) => {
                                            e.preventDefault(); // Prevent default anchor behavior
                                            changeTab4(index);
                                                    }}
                                        >
                                            <img className="img_simple" width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon.svg" alt="" />
                                            <img className="img_active" width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon_active.svg" alt="" />
                                            <span>{tab.label}</span>
                                        </a>
                                        </li>
                                    ))}
                            </ul>
                        
                            <div className="tab-content">
                            
                                {/* START Tab 1 */}
                                <div className={`tab-pane ${currentTabIndexMorden === 0 ? "active" : ""}`}
                                id="mostMorden_1">
                                    <div className='mostMordenCommon'>
                                            <div className='row'>
                                                <div className='col-lg-12 col-md-12'>
                                                    <div className='mostHostInner'>
                                                        <h3>Host Booking Experience</h3>
                                                        <p>Our <span>smart booking management</span> system integrates reservation data into 
                                                        automated workflows, streamlining your rental operations. Effortlessly process bookings, 
                                                        prepare vehicles, and stay connected with guests to deliver outstanding experiences. 
                                                        Simplify operations, enhance guest satisfaction, and unlock growth for your rental 
                                                        business.</p>
                                                        <ul>
                                                            <li>Fleet Management</li>
                                                            <li>Daily Insurance</li>
                                                            <li>ID Verification</li>
                                                            <li>Insurance Validation</li>
                                                            <li>Fraud Detection</li>
                                                            <li>Branding</li>
                                                            <li>Marketing</li>
                                                            <li>Inbox Messaging</li>
                                                            <li>Cancellation Policy</li>
                                                            <li>Resolution Center</li>
                                                            {/* <li>Payments</li> */}
                                                            <li>Customize Platform </li>
                                                            <li>Analytics</li>
                                                        </ul>

                                                        <figure>
                                                            <img className="img-fluid" src="/img/rentdirect/host-bookigns-house.png" alt="Most Morden"/>
                                                        </figure> 

                                                        {/* <video width="100%"  controls loop autoPlay muted playsInline>
                                                            <source src="/img/rentdirect/host-video.mov" type="video/mp4" />
                                                        </video> */}
                                                    </div>
                                                </div>
                                            </div>
                                    </div> 
                                </div> 
                                {/* END Tab 1 */}

                                {/* START Tab 2 */}
                                <div className={`tab-pane ${currentTabIndexMorden === 1 ? "active" : ""}`}
                                id="mostMorden_2">
                                    <div className='mostMordenCommon'>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='mostGuestLeft'>
                                                <h3>Guest Booking Experience</h3>
                                                    <p>Booking is effortless with our <span>smart booking management</span> system. 
                                                    Guests can search on your branded website or app and follow a modernized rental journey to access all trip details, 
                                                    ensuring a truly seamless travel experience from start to finish</p>
                                                    <ul>
                                                        <li>Branded Experience</li>
                                                        <li>Search</li>
                                                        <li>Promotions</li>
                                                        <li>Protection Plans</li>
                                                        <li>Extras</li>
                                                        <li>Secure Payments</li>
                                                        <li>ID Verification</li>
                                                        <li>Insurance Validation</li>
                                                        <li>Scheduled Instructions</li>
                                                        <li>Messaging</li>
                                                        <li>Start Trip</li>
                                                        <li>End Trip</li>
                                                        <li>Trip Photos</li>
                                                        <li>Rental Agreement</li>
                                                        <li>Insurance Card</li>
                                                        <li>Modify Trip</li>
                                                        <li>File Claim</li>
                                                        <li>Review System</li>
                                                        <li>Leave Tip</li>
                                                        <li>Remarketing</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='mostGuestRight'>
                                                    {/* <button type="button" id="rentdirect_popup" className="waitlist_pop" onClick={handleModal} style={{ border: "none", background: "none", padding: 0 }}>
                                                        <img className="guest_booking_icon" src="/img/rentdirect/guest_booking_icon.svg" alt="Guest Booking" />
                                                    </button>

                                                <img className="guest_booking_img" src="/img/rentdirect/guest_booking.png" /> */}
                                                
                                                    <video width="380" height="572" controls loop autoPlay muted playsInline>
                                                        <source src="/img/rentdirect/guest-video.mp4" type="video/mp4" />
                                                    </video> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 2 */}

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section ref={sectionRef4} className="mostMordenMain mostMorden_MobileMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="headmostMorden">
                                <h2>The most modern & intuitive booking experience designed for vehicle rental</h2>
                                <p>Say hello to seamless rental operations, customizable and automated booking workflows that enhance productivity.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-11"> 
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <span>Host Booking Experience</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='mostMorden_MobileCommon'>
                                        <div className='row'>
                                            <div className='col-lg-12 col-md-12'>
                                                <div className='mostHostMobileInner'>
                                                    <h3>Host Booking Experience</h3>
                                                    <p>Our <span>smart booking management</span> system integrates reservation data into 
                                                    automated workflows, streamlining your rental operations. Effortlessly process bookings, 
                                                    prepare vehicles, and stay connected with guests to deliver outstanding experiences. 
                                                    Simplify operations, enhance guest satisfaction, and unlock growth for your rental 
                                                    business.</p>
                                                    <ul>
                                                        <li>Fleet Management</li>
                                                        <li>Daily Insurance</li>
                                                        <li>ID Verification</li>
                                                        <li>Insurance Validation</li>
                                                        <li>Fraud Detection</li>
                                                        <li>Branding</li>
                                                        <li>Marketing</li>
                                                        <li>Inbox Messaging</li>
                                                        <li>Cancellation Policy</li>
                                                        <li>Resolution Center</li>
                                                        {/* <li>Payments</li> */}
                                                        <li>Customize Platform </li>
                                                        <li>Analytics</li>
                                                    </ul>

                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/host-bookigns-house.png" alt="Most Morden"/>
                                                    </figure> 

                                                    {/* <video width="100%"  controls loop autoPlay muted playsInline>
                                                        <source src="/img/rentdirect/host-video.mov" type="video/mp4" />
                                                    </video> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <span>Guest Booking Experience</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    
                                    <div className='mostMorden_MobileCommon'>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='mostGuest_MobileLeft'>
                                                <h3>Guest Booking Experience</h3>
                                                    <p>Booking is effortless with our <span>smart booking management</span> system. 
                                                    Guests can search on your branded website or app and follow a modernized rental journey to access all trip details, 
                                                    ensuring a truly seamless travel experience from start to finish</p>
                                                    <ul>
                                                        <li>Branded Experience</li>
                                                        <li>Search</li>
                                                        <li>Promotions</li>
                                                        <li>Protection Plans</li>
                                                        <li>Extras</li>
                                                        <li>Secure Payments</li>
                                                        <li>ID Verification</li>
                                                        <li>Insurance Validation</li>
                                                        <li>Scheduled Instructions</li>
                                                        <li>Messaging</li>
                                                        <li>Start Trip</li>
                                                        <li>End Trip</li>
                                                        <li>Trip Photos</li>
                                                        <li>Rental Agreement</li>
                                                        <li>Insurance Card</li>
                                                        <li>Modify Trip</li>
                                                        <li>File Claim</li>
                                                        <li>Review System</li>
                                                        <li>Leave Tip</li>
                                                        <li>Remarketing</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='mostGuest_MobileRight'>
                                                    <video width="380" height="572" controls loop autoPlay muted playsInline>
                                                        <source src="/img/rentdirect/guest-video.mp4" type="video/mp4" />
                                                    </video> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        {/* END mostMordenMain */}


        <YourBrand/>


        {/* START madeMarketingMain */}
        <section ref={sectionRef} className="madeMarketingMain madeMarketing_DesktopMain" id='marketing_main'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="headmadeMarketing">
                            <h2><span>Marketing made simple.</span> Keep renters coming back with built-in campaigns that work.</h2>
                        </div>
                    </div>
                </div>
 
                <ul className="nav nav-tabs">
                    {tabsData.map((tab, index) => (
                        <li key={tab} className="nav-item">
                        <a
                            className={`nav-link ${currentTabIndexMarketing === index ? "active" : ""}`}
                            id={tab.id}
                            data-bs-toggle="tab"
                            href={`#${tab.id}`}
                            onClick={(e) => {
                            e.preventDefault();
                            changeTab(index);
                                    }}
                        >
                            <img width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon.svg" alt="icon" />
                            <span>{tab.label}</span>
                        </a>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="madeMarketingOuter">
                <div className="container">   
                    <div className="tab-content">
                        {/* START Tab 1 */}
                        <div className={`tab-pane ${currentTabIndexMarketing === 0 ? "active" : ""}`} id="madeMarketing_1">
                            <div className="commonMadeMarketing">
                                <div className='row align-items-center'>
                                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingLeft'>
                                            <h3><span>Curate a collection of vehicles </span>for a quote</h3>
                                            <p>Create tailored lists for specific guests, complete with exclusive offers, 
                                            booking links and expires on a date you set ensuring a seamless, customized
                                            quote experience.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingRight'>
                                            <figure>
                                                <img className="img-fluid" width="621px" src="/img/rentdirect/madeMarketing_1.png" alt="vehicle collection"/>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* START Tab 2 */}
                        <div className={`tab-pane ${currentTabIndexMarketing === 1 ? "active" : ""}`} id="madeMarketing_2">

                            <div className="commonMadeMarketing">
                                <div className='row align-items-center'>
                                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingLeft'>
                                            <h3>Built in <span>promotional & discount</span> programs</h3>
                                            <p>Create system-wide promotions with percentage discounts or usage-based codes 
                                            available at checkout. You can also offer automatic daily or weekly discounts 
                                            when guests book the required minimum rental duration.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingRight'>
                                            <figure>
                                                <img className="img-fluid" width="613px" src="/img/rentdirect/madeMarketing_2.webp" alt="promotional & discount programs"/>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        {/* START Tab 3 */}
                        <div className={`tab-pane ${currentTabIndexMarketing === 2 ? "active" : ""}`} id="madeMarketing_3">

                            <div className="commonMadeMarketing">
                                <div className='row align-items-center'>
                                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingLeft'>
                                            <h3><span>Spotlight</span> noteworthy <span>headlines & promotions</span></h3>
                                            <p>Keep your brand top of mind with Spotlight. Highlight your promo or announcement and 
                                            feature it prominently in your dedicated storefront. Guests see your offer whenever 
                                            they explore your page, ensuring your brand stays in focus and drives engagement.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketingRight'>
                                            <video controls loop autoPlay muted playsInline>
                                                <source src="/img/rentdirect/madeMarketing_3.mov" type="video/mp4" />
                                            </video>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentdirect/madeMarketing_3.png" alt="headlines & promotions"/>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </section>

        <section className="madeMarketingMain madeMarketing_MobileMain">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="headmadeMarketing">
                            <h2><span>Marketing made simple.</span> Keep renters coming back with built-in campaigns that work.</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="madeMarketingOuter">
                <div className="container">   
                    <Accordion defaultActiveKey="0">
                        {/* start 1 */}
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <span>Collections</span>
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className="commonMade_MobileMarketing commonMade_MobileMarketing_1">
                                <div className='row align-items-center'>
                                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketing_MobileLeft'>
                                            <h3><span>Curate a collection of vehicles </span>for a quote</h3>
                                            <p>Create tailored lists for specific guests, complete with exclusive offers, 
                                            booking links and expires on a date you set ensuring a seamless, customized
                                            quote experience.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketing_MobileRight'>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentdirect/madeMarketing_1.png" alt="vehicle collection"/>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* start 2 */}
                        <Accordion.Item eventKey="1">
                            <Accordion.Header> 
                                <span>Promotions</span>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="commonMade_MobileMarketing commonMade_MobileMarketing_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                            <div className='madeMarketing_MobileLeft'>
                                                <h3>Built in <span>promotional & discount</span> programs</h3>
                                                <p>Create system-wide promotions with percentage discounts or usage-based codes 
                                                available at checkout. You can also offer automatic daily or weekly discounts 
                                                when guests book the required minimum rental duration.</p>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                            <div className='madeMarketing_MobileRight'>
                                                <figure>
                                                    <img className="img-fluid" width="613px" src="/img/rentdirect/madeMarketing_2.webp" alt="promotional & discount programs"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* start 3 */}
                        <Accordion.Item eventKey="3">
                            <Accordion.Header> 
                                <span>Spotlight</span>
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className="commonMade_MobileMarketing commonMade_MobileMarketing_3">
                                <div className='row align-items-center'>
                                    <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketing_MobileLeft'>
                                            <h3><span>Spotlight</span> noteworthy <span>headlines & promotions</span></h3>
                                            <p>Keep your brand top of mind with Spotlight. Highlight your promo or announcement and 
                                            feature it prominently in your dedicated storefront. Guests see your offer whenever 
                                            they explore your page, ensuring your brand stays in focus and drives engagement.</p>
                                        </div>
                                    </div>
                                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                        <div className='madeMarketing_MobileRight'>
                                            <video controls loop autoPlay muted playsInline>
                                                <source src="/img/rentdirect/madeMarketing_3.mov" type="video/mp4" />
                                            </video>
                                            <figure>
                                                <img className="img-fluid" src="/img/rentdirect/madeMarketing_3.png" alt="headlines & promotions"/>
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
        </section>        
        {/* END madeMarketingMain */}

        
        {/* START fleetManagementMain */}
        <div id="FleetManagementCenter">
            <section ref={sectionRef1} className="fleetManagementMain fleetManagement_DesktopMain">
                <img className="fleet_1" src="/img/rentdirect/fleet_1.svg" alt="Fleet Management Center"/>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="headFleetManagement">
                                <h2>Fleet Management Center</h2>
                                <p>Manage your fleet with tools that cover every detail, from vehicle tracking to issue resolution, 
                                    ensuring smooth operations.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                        <ul className="nav nav-tabs">
                        {fleettabs.map((tab, index) => (
                            <li key={tab} className="nav-item">
                            <a
                                className={`nav-link ${currentTabIndexFleet === index ? "active" : ""}`}
                                id={tab.id}
                                data-bs-toggle="tab"
                                href={`#${tab.id}`}
                                onClick={(e) => {
                                e.preventDefault();
                                changeTab1(index);
                                        }}

                            >
                                <img width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon.svg" alt="icon" />
                                <span>{tab.label}</span>
                            </a>
                            </li>
                        ))}
                        </ul>

                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className={`tab-pane ${currentTabIndexFleet === 0 ? "active" : ""}`}
                                id="fleetManagement_1">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementLeft'>
                                                <h3>Booking Data & Calendar</h3>
                                                <p>Effortlessly manage bookings, vehicle availability, and maintenance schedules all in one place.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Instantly identify the status of current and upcoming vehicle events.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Easily mark vehicles unavailable for routine maintenance or repairs.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Click any event to quickly access details, approve requests, or make changes.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementRight'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/fleet_management_1.webp" alt="Fleet Management"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* START Tab 2 */}
                                <div className={`tab-pane ${currentTabIndexFleet === 1 ? "active" : ""}`}
                                id="fleetManagement_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementLeft'>
                                                <h3>Fleet Manager</h3>
                                                <p>Gain complete control and visibility over your vehicles, ensuring every aspect of your 
                                                operations runs smoothly.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Access real-time rental insights into every vehicle</span></li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Optimize operations and schedule maintenance proactively</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Ensure your fleet is always ready to meet customer demand.</span>
                                                    </li>
                                                </ul>
                                            
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementRight'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/fleet_management_2.webp" alt="Fleet Management"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div> 

                                {/* START Tab 3 */}
                                <div className={`tab-pane ${currentTabIndexFleet === 2 ? "active" : ""}`}
                                id="fleetManagement_3">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementLeft'>
                                                <h3>Vehicle Profile Manager</h3>
                                                <p>Showcase your vehicles and maintain complete control over individual listings.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Set specific requirements such as trip duration, coverage minimums, and distance limits. </span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span> Define cancellation rules that align with your business goals while keeping renters informed.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span> Tailor pricing for different seasons, holidays, or booking durations to stay competitive.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span> Define custom pickup and drop-off locations to enhance convenience for renters. </span>
                                                    </li>
                                                </ul>
                                            
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementRight'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/fleet_management_3.webp" width alt="Fleet Management"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* START Tab 4 */}
                                <div className={`tab-pane ${currentTabIndexFleet === 3 ? "active" : ""}`}
                                id="fleetManagement_4">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementLeft'>
                                                <h3>Telematics & Tracking</h3>
                                                <p>Stay connected to your fleet like never before with  telematics and tracking integrations.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Monitor each vehicle’s location, status and activity from a centralized dashboard</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                        <span>Access driving behavior such as speed, braking, and acceleration to promote safe vehicle use.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                            <div className='fleetManagementRight'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/fleet_management_4.webp" alt="Fleet Management"/>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fleetManagementMain fleetManagement_MobileMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="headFleetManagement">
                                <h2>Fleet Management Center</h2>
                                <p>Manage your fleet with tools that cover every detail, from vehicle tracking to issue resolution, 
                                    ensuring smooth operations.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <span>Booking Calender</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileLeft'>
                                                    <h3>Booking Data & Calendar</h3>
                                                    <p>Effortlessly manage bookings, vehicle availability, and maintenance schedules all in one place.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Instantly identify the status of current and upcoming vehicle events.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Easily mark vehicles unavailable for routine maintenance or repairs.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Click any event to quickly access details, approve requests, or make changes.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileRight'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/fleet_management_1.webp" alt="Fleet Management"/>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header> 
                                        <span>Fleet Manager</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileLeft'>
                                                    <h3>Fleet Manager</h3>
                                                    <p>Gain complete control and visibility over your vehicles, ensuring every aspect of your 
                                                    operations runs smoothly.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Access real-time rental insights into every vehicle</span></li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Optimize operations and schedule maintenance proactively</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Ensure your fleet is always ready to meet customer demand.</span>
                                                        </li>
                                                    </ul>
                                                
                                                </div>
                                            </div>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileRight'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/fleet_management_2.webp" alt="Fleet Management"/>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header> 
                                        <span>Vehicle Profile</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileLeft'>
                                                    <h3>Vehicle Profile Manager</h3>
                                                    <p>Showcase your vehicles and maintain complete control over individual listings.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Set specific requirements such as trip duration, coverage minimums, and distance limits. </span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span> Define cancellation rules that align with your business goals while keeping renters informed.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span> Tailor pricing for different seasons, holidays, or booking durations to stay competitive.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span> Define custom pickup and drop-off locations to enhance convenience for renters. </span>
                                                        </li>
                                                    </ul>
                                                
                                                </div>
                                            </div>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileRight'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/fleet_management_3.webp" width alt="Fleet Management"/>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header> 
                                        <span>Telematics & Tracking</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileLeft'>
                                                    <h3>Telematics & Tracking</h3>
                                                    <p>Stay connected to your fleet like never before with  telematics and tracking integrations.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Monitor each vehicle’s location, status and activity from a centralized dashboard</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                                            <span>Access driving behavior such as speed, braking, and acceleration to promote safe vehicle use.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                                <div className='fleetManagement_MobileRight'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/fleet_management_4.webp" alt="Fleet Management"/>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        {/* END fleetManagementMain */}
       


        {/* START customerRelationshipMain */}
        <div id="CustomerRelationshipTools">

            <section ref={sectionRef2}  className="customerRelationshipMain customerRel_DesktopMain">

                {/* <img className="customerRelationship_1" src="/img/rentdirect/customer_Relationship_Deco.svg" alt="Customer Relationship Tools"/> */}

                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="headcustomerRelationship">
                            <h2>Customer Relationship Tools</h2>
                            <p>Strengthen guest relationships with tools that simplify 
                            <span>engagement, provide insights, and support every interaction.</span></p>
                        </div>
                    </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                        <ul className="nav nav-tabs realtionable-main-table">
                        {customerrelationshipettabs.map((tab, index) => (
                            <li key={tab} className="nav-item">
                            <a
                                className={`nav-link ${currentTabCustomer === index ? "active" : ""}`}
                                id={tab.id}
                                data-bs-toggle="tab"
                                href={`#${tab.id}`}
                                onClick={(e) => {
                                e.preventDefault();
                                changeTab2(index);
                                        }}
                            >
                                <img width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon.svg" alt="icon" />
                                <span>{tab.label}</span>
                            </a>
                            </li>
                        ))}
                        </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className={`tab-pane ${currentTabCustomer === 0 ? "active" : ""}`}
                                id="customerRelationship_1">
                        
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_1.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/white_star.svg" alt="star"/>
                                                <h3>Review Management</h3>
                                                <p>Foster trust and build better connections. Hosts and guests can leave reviews for each 
                                                other after every trip, sharing feedback about the experience. Your voice helps create 
                                                a stronger, more reliable community for everyone.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Manage Reviews with Ease:</strong> Use your dashboard to view, respond to, and track feedback effortlessly.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Star Rating:</strong> Share your experience with a quick and simple star rating system.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Add a Personal Touch:</strong> Write personalized reviews to highlight great experiences or provide constructive feedback.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Earn Tips for Outstanding Service:</strong> Accept tips directly from guests to recognize your exceptional efforts.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* START Tab 2 */}
                                <div className={`tab-pane ${currentTabCustomer === 1 ? "active" : ""}`}
                                id="customerRelationship_2">
    
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_2.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/white_user.svg" alt="star"/>
                                                <h3>Comprehensive Guest Profile</h3>
                                                <p>Make informed decisions with our comprehensive guest profiles that provide you with 
                                                the insights you need to confidently approve bookings, protect your vehicle, and 
                                                enhance the rental experience.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>DriverIQ™ Score:</strong> Access a detailed risk assessment powered by AI to evaluate guests before approving bookings</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Verification &Validation:</strong> Verify guest information, identity and auto insurance in seconds, ensuring peace of mind.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Booking History:</strong> Review past rentals and guest reviews to understand their reliability and trustworthiness.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Actionable Insights:</strong> Leverage data-driven metrics for smarter decision-making and a more secure rental process.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 

                                {/* START Tab 3 */}
                                <div className={`tab-pane ${currentTabCustomer === 2 ? "active" : ""}`}
                                id="customerRelationship_3">
                            
                                <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_3.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRelationshipRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/scheduled_icon.svg" alt="star"/>
                                                <h3>Scheduled & Automated Messages</h3>
                                                <p>Enhance communication with Scheduled & Automated Messages, a powerful tool for managing
                                                guest interactions. Customize templates to send timely, personalized updates based on
                                                key rental events, ensuring a professional and smooth experience for your guests.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Event-Based Messaging:</strong> Send automated updates for bookings, vehicle pick-ups, returns, and other key moments.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Customizable Templates:</strong> Create tailored messages that align with your brand and tone.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Personalized Touch:</strong> Add guest names and rental details for clear and professional communication.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Efficient Automation:</strong> Keep guests informed while saving time on repetitive tasks.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}
                

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section  className="customerRelationshipMain customerRel_MobileMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="headcustomerRelationship">
                                <h2>Customer Relationship Tools</h2>
                                <p>Strengthen guest relationships with tools that simplify 
                                <span>engagement, provide insights, and support every interaction.</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <span>Review Management</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_1.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/white_star.svg" alt="star"/>
                                                <h3>Review Management</h3>
                                                <p>Foster trust and build better connections. Hosts and guests can leave reviews for each 
                                                other after every trip, sharing feedback about the experience. Your voice helps create 
                                                a stronger, more reliable community for everyone.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Manage Reviews with Ease:</strong> Use your dashboard to view, respond to, and track feedback effortlessly.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Star Rating:</strong> Share your experience with a quick and simple star rating system.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Add a Personal Touch:</strong> Write personalized reviews to highlight great experiences or provide constructive feedback.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Earn Tips for Outstanding Service:</strong> Accept tips directly from guests to recognize your exceptional efforts.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header> 
                                        <span>Comprehensive Guest Profile</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_2.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/white_user.svg" alt="star"/>
                                                <h3>Comprehensive Guest Profile</h3>
                                                <p>Make informed decisions with our comprehensive guest profiles that provide you with 
                                                the insights you need to confidently approve bookings, protect your vehicle, and 
                                                enhance the rental experience.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>DriverIQ™ Score:</strong> Access a detailed risk assessment powered by AI to evaluate guests before approving bookings</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Verification &Validation:</strong> Verify guest information, identity and auto insurance in seconds, ensuring peace of mind.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Booking History:</strong> Review past rentals and guest reviews to understand their reliability and trustworthiness.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Actionable Insights:</strong> Leverage data-driven metrics for smarter decision-making and a more secure rental process.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                          
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header> 
                                        <span>Scheduled Messages</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/customerRelationship_3.png" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='customerRel_MobileRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/scheduled_icon.svg" alt="star"/>
                                                <h3>Scheduled & Automated Messages</h3>
                                                <p>Enhance communication with Scheduled & Automated Messages, a powerful tool for managing
                                                guest interactions. Customize templates to send timely, personalized updates based on
                                                key rental events, ensuring a professional and smooth experience for your guests.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Event-Based Messaging:</strong> Send automated updates for bookings, vehicle pick-ups, returns, and other key moments.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Customizable Templates:</strong> Create tailored messages that align with your brand and tone.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Personalized Touch:</strong> Add guest names and rental details for clear and professional communication.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Efficient Automation:</strong> Keep guests informed while saving time on repetitive tasks.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                             
                                    </Accordion.Body>
                                </Accordion.Item>

                              
                            </Accordion>
                        </div>
                    </div>

                </div>
            </section>
        </div>
        {/* END customerRelationshipMain */}

        {/* START financialManagementsMain */}
        <div id="FinancialManagement">
            <section ref={sectionRef3} className="financialManagementsMain financialManage_DesktopMain">
                {/* <img className="financialManagements_1" src="/img/rentdirect/financialManagements_1.svg" alt="Financial Management"/> */}
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="headFinancialManagements">
                            <h2>Financial Management</h2>
                            <p>Easily manage transactions with solutions that support your rental business.</p>
                        </div>
                    </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                        <ul className="nav nav-tabs  ">
                        {financialtabs.map((tab, index) => (
                            <li key={tab} className="nav-item">
                            <a
                                className={`nav-link ${currentTabFinancial === index ? "active" : ""}`}
                                id={tab.id}
                                data-bs-toggle="tab"
                                href={`#${tab.id}`}
                                onClick={(e) => {
                                e.preventDefault();
                                changeTab3(index);
                                        }}
                            >
                                <img className="img_simple" width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon.svg" alt="" />
                                <img className="img_active" width="22px" height="24px" src="/img/rentdirect/most_morden_shield_icon_active.svg" alt="" />
                                <span>{tab.label}</span>
                            </a>
                            </li>
                        ))}
                        </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className={`tab-pane ${currentTabFinancial === 0 ? "active" : ""}`}
                                id="financialManagements_1">
                            
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/financialManagements_1.webp" alt="Dynamic Invoices"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/dynamic_icon.svg" alt="star"/>
                                                <h3>Dynamic Invoices</h3>
                                                <p>Rentid's dynamic invoices use real-time booking data from your guests and your 
                                                    customizations, ensuring every invoice is accurate, tailored, and up-to-date. 
                                                    No more paperwork – everything is digitally organized in your portal and app, 
                                                    making it easy to manage payments and maintain financial records.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Real-Time Customization:</strong> Invoices automatically adjust based on booking details like dates, rates, fees, and add-ons.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Efficient Management:</strong> Eliminate manual data entry, saving time and minimizing errors.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Clear Documentation:</strong> Provide guests with accurate, itemized invoices for a professional experience.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Organized Records:</strong> Keep all invoices accessible in your portal for easy tracking and financial management.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* START Tab 2 */}
                                <div className={`tab-pane ${currentTabFinancial === 1 ? "active" : ""}`}
                                id="financialManagements_2">
                            
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/financialManagements_2.webp" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/dynamic_icon.svg" alt="star"/>
                                                <h3>Dynamic Rental Agreements</h3>
                                                <p>Rentid's dynamic rental agreements automatically adapt to each booking, ensuring every agreement is precise, customized, and compliant. 
                                                    Everything is stored digitally in your portal for easy access and management.</p>
                                                    <h4>Refund Steps</h4>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Tailored to Every Booking:</strong> Agreements update in real time with details like rental dates, terms, and fees.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Professional Communication:</strong> Ensure guests receive clear, consistent agreements for transparency.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Compliance and Trust:</strong> Built to adhere to platform standards, providing a seamless and trustworthy experience.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Digital Accessibility:</strong> Manage all agreements in one place, reducing paperwork and improving organization.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 

                                {/* START Tab 3 */}
                                <div className={`tab-pane ${currentTabFinancial === 2 ? "active" : ""}`}
                                id="financialManagements_3">
                        
                                <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/rentdirect/financialManagements_3.webp" alt="Customer Relationship"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='financialManagementsRight'>
                                                <img width="48px" height="48px" src="/img/rentdirect/payment_icon.svg" alt="star"/>
                                                <h3>Payment Methods</h3>
                                                <p>Gain valuable insights into your business with our powerful analytics and reporting tools. Make informed, 
                                                    data-driven decisions by accessing real-time metrics and customizable reports. Understand trends, 
                                                    identify opportunities for improvement, and forecast future performance to drive sustainable growth.</p>
                                                <ul>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Real-Time Performance Metrics:</strong> Stay updated on key indicators.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Customizable Dashboards:</strong> Tailor views to focus on what matters most.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Fleet Utilization Reports:</strong> Optimize vehicle usage and availability.</span>
                                                    </li>
                                                    <li>
                                                        <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                        <span><strong>Revenue Analysis:</strong> Understand financial trends and patterns.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}
                

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section  className="financialManagementsMain financialManage_MobileMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headFinancialManagements">
                                <h2>Financial Management</h2>
                                <p>Easily manage transactions with solutions that support your rental business.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <Accordion defaultActiveKey="0">
                                    {/* start 1 */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <span>Dynamic Invoices</span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='financialManage_MobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/financialManagements_11.webp" alt="Dynamic Invoices"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='financialManage_MobileRight'>
                                                    <img width="48px" height="48px" src="/img/rentdirect/dynamic_icon.svg" alt="star"/>
                                                    <h3>Dynamic Invoices</h3>
                                                    <p>Rentid's dynamic invoices use real-time booking data from your guests and your 
                                                        customizations, ensuring every invoice is accurate, tailored, and up-to-date. 
                                                        No more paperwork – everything is digitally organized in your portal and app, 
                                                        making it easy to manage payments and maintain financial records.</p>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Real-Time Customization:</strong> Invoices automatically adjust based on booking details like dates, rates, fees, and add-ons.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Efficient Management:</strong> Eliminate manual data entry, saving time and minimizing errors.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Clear Documentation:</strong> Provide guests with accurate, itemized invoices for a professional experience.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Organized Records:</strong> Keep all invoices accessible in your portal for easy tracking and financial management.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
    
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* start 2 */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header> 
                                            <span>Dynamic Agreements</span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='financialManage_MobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/rentdirect/financialManagements_2.webp" alt="Customer Relationship"/>

                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='financialManage_MobileRight'>
                                                    <img width="48px" height="48px" src="/img/rentdirect/dynamic_icon.svg" alt="star"/>
                                                    <h3>Dynamic Rental Agreements</h3>
                                                    <p>Rentid's dynamic rental agreements automatically adapt to each booking, ensuring every agreement is precise, customized, and compliant. 
                                                        Everything is stored digitally in your portal for easy access and management.</p>
                                                        <h4>Refund Steps</h4>
                                                    <ul>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Tailored to Every Booking:</strong> Agreements update in real time with details like rental dates, terms, and fees.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Professional Communication:</strong> Ensure guests receive clear, consistent agreements for transparency.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Compliance and Trust:</strong> Built to adhere to platform standards, providing a seamless and trustworthy experience.</span>
                                                        </li>
                                                        <li>
                                                            <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                            <span><strong>Digital Accessibility:</strong> Manage all agreements in one place, reducing paperwork and improving organization.</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                            
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* start 3 */}
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header> 
                                            <span>Payment Methods</span>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div className='row align-items-center'>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='financialManage_MobileLeft'>
                                                        <figure>
                                                            <img className="img-fluid" src="/img/rentdirect/financialManagements_3.webp" alt="Customer Relationship"/>
                                                        </figure>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                    <div className='financialManage_MobileRight'>
                                                        <img width="48px" height="48px" src="/img/rentdirect/payment_icon.svg" alt="star"/>
                                                        <h3>Payment Methods</h3>
                                                        <p>Gain valuable insights into your business with our powerful analytics and reporting tools. Make informed, 
                                                            data-driven decisions by accessing real-time metrics and customizable reports. Understand trends, 
                                                            identify opportunities for improvement, and forecast future performance to drive sustainable growth.</p>
                                                        <ul>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                                <span><strong>Real-Time Performance Metrics:</strong> Stay updated on key indicators.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                                <span><strong>Customizable Dashboards:</strong> Tailor views to focus on what matters most.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                                <span><strong>Fleet Utilization Reports:</strong> Optimize vehicle usage and availability.</span>
                                                            </li>
                                                            <li>
                                                                <img width="24px" height="24px" src="/img/rentdirect/check_white.svg" alt="icon"/>
                                                                <span><strong>Revenue Analysis:</strong> Understand financial trends and patterns.</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                
                                        </Accordion.Body>
                                    </Accordion.Item>

                                
                                </Accordion>
                            </div>
                        </div>
        
                
                </div>
            </section>
        </div>
        {/* END financialManagementsMain */}

        {/* START analyticsReportingMain */}
        <section className="analyticsReportingMain" id="AnalyticsReporting">
            <div className="container">
                <div className="row">
                <div className="col-lg-10">
                    <div className="headAnalyticsReporting">
                        <h2>Analytics & Reporting</h2>
                    </div>
                </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <div className='analyticsReportingLeft'>
                            <img width="41px" height="41px" src="/img/analytics_icon_2.svg" alt="star"/>
                            <h3>Data-Driven Decisions for Growth</h3>
                            <p>Gain valuable insights into your business with our powerful analytics and reporting tools. 
                                Make informed, data-driven decisions by accessing real-time metrics and customizable reports. 
                                Understand trends, identify opportunities for improvement, and forecast future performance to 
                                drive sustainable growth.</p>
                            <ul>
                                <li>
                                    <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                    <span><strong>Real-Time Performance Metrics:</strong> Monitor key indicators to stay informed and make data-driven decisions.</span>
                                </li>
                                <li>
                                    <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                    <span><strong>Customizable Dashboards:</strong> Focus on what matters most by tailoring views to your needs.</span>
                                </li>
                                <li>
                                    <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                    <span><strong>Fleet and Revenue Insights:</strong> Optimize vehicle usage and track financial trends with detailed reports.</span>
                                </li>
                                <li>
                                    <img width="24px" height="24px" src="/img/rentdirect/check_fleet.svg" alt="check"/>
                                    <span><strong>Customer Behavior and Trends:</strong> Learn from customer interactions and forecast market changes to refine strategies.</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                        <div className='analyticsReportingRight'>
                            <img className="img-fluid" src="/img/rentdirect/analytics_reporting.webp" alt="Data-Driven Decisions for Growth"/>
                            <img className="analytics_reporting_2" src="/img/rentdirect/analytics_reporting_2.webp" alt="Data-Driven Decisions for Growth"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* END analyticsReportingMain */}

        {/* START resolutionCenterMain */}
        <section className="resolutionCenterMain">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9">
                        <div className="headResolutionCenter" id="headresolutioncenter">
                            <h2>Incidents tend to happen during rental periods.</h2>
                        </div>
                    </div>
                </div>
                <div className='resolutionCenterOuter'>
                    <div className='row align-items-center'>
                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                            <div className='resolutionCenterLeft'>
                                <figure>
                                    <img className="img-fluid" src="/img/rentdirect/resolution_center.webp" alt="Resolution Center" />
                                </figure>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                            <div className='resolutionCenterRight'>
                                <h3>Visit the Resolution Center</h3>
                                <p>Resolve incidents with guests, recover funds, and handle simple or complex rentals confidently.</p>
                                <ul>
                                    <li>
                                        <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                                        <span>Trip Refunds</span>
                                    </li>
                                    <li>
                                        <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                                        <span>Insurance Claims</span>
                                    </li>
                                    <li>
                                        <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                                        <span>Guest Violations</span>
                                    </li>
                                    <li>
                                        <img width="16px" height="16px" src="/img/tick-grade.svg" alt="icon" />
                                        <span>Report Guest</span>
                                    </li>
                                </ul>
                                <a className="btn btnTransparent_2" href="/rentsuccess">Learn More
                                    <img width="24px" height="24px" src="/img/arrow-right-white.svg" alt="icon"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='resolutionCenterBottom'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12'>
                            <img className="img-fluid"  src="/img/power_success.svg" alt="icon" />
                        </div>
                    </div>
                </div>

            </div>
        </section>
        {/* END resolutionCenterMain */}
        
        {/* START moreSolutionMain */}
        <section className='moreSolutionMain'>
            <div className='container'>
                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="moreSolutionHeading">
                                <h2>Discover more solutions</h2>
                                <p>Rental tools to help you scale your business</p>
                            </div>
                        </div>
                    </div>

                    <div className='moreSolutionOuter'>

                        <div className="moreSolutionInner moreSolutionSky">
                            <a href="/rent-id">
                                <div className="sky_overlay"></div>
                                <figure> <img src="/img/rent_id_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionRed">
                            <a href="/rentshield">
                                <div className="red_overlay"></div>
                                <figure><img src="/img/rent_shield_logo.png" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionwhite">
                            <a href="/rentai">
                                <div className="white_overlay"></div>
                                <figure> <img src="/img/rent_ai_logo.svg" alt="logo"/></figure>
                            </a>
                        </div>

                        <div className="moreSolutionInner moreSolutionPurple">
                            <a href="/rentsuccess">
                                <div className="purple_overlay"></div>
                                <figure><img src="/img/rent_success_logo.png" alt="logo"/></figure>
                            </a>
                        </div>
                        <div className="moreSolutionInner moreSolutionYellow">
                            <a href="/rentacademy">
                                <div className="yellow_overlay"></div>
                                <figure> <img src="/img/rent_academy_logo.png" alt="logo"/></figure>
                            </a>
                        </div>
                    </div>
            </div>
        </section> 
        {/* END moreSolutionMain */}


        </div>
        </>
    )
}

export default RentDirectPage;